import { withTranslation } from 'react-i18next';
import TermsOfService from './TermsOfService.layout';

export default withTranslation('open-banking')(TermsOfService);
